import ChangeInteriorColor from 'components/ProductSidebar/menus/Widgets/ChangeColor/ChangeInteriorColor';
import { ConfigOptions, MainMenu, SortingConfig, SubMenuType, Widget } from 'rangeConfig/@types';
import interiorsProductListConfig from './productListConfig';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import platform from 'rangeConfig/shared/utils/platform';
import { interiorsTypeFilter } from 'rangeConfig/pax/filters/configFilters';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import {
  hideNoFramesInSceneErrorMessage,
  noFrameSelected
} from 'rangeConfig/shared/rules/hideMenuRules';
import { InteriorSuggestionsLayoutMessage } from 'rangeConfig/pax/widgets/interiorSuggestions/InteriorSuggestionsLayoutMessage';
import InteriorSuggestions from 'rangeConfig/pax/widgets/interiorSuggestions/InteriorSuggestions';
import showClothHangersSheet from 'rangeConfig/shared/behaviors/showClothHangersSheet';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { getNoFramesInSceneErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import {
  sortByPriceAscending,
  sortByPriceDescending,
  defaultSort
} from 'rangeConfig/shared/sorting/sortingConfigs';
import disableDistanceMeasurements from 'rangeConfig/shared/behaviors/disableDistanceMeasurements';
import enableDistanceMeasurements from 'rangeConfig/shared/behaviors/enableDistanceMeasurements';
import { InteriorSuggestionsMenuPadding } from 'rangeConfig/pax/widgets/interiorSuggestions/InteriorSuggestionsMenuPadding';

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'change-interior-color',
      component: ChangeInteriorColor
    }
  ],
  mobile: [
    {
      id: 'interior-suggestions',
      component: InteriorSuggestions,
      title: 'storageone.combinationsTabTitle'
    }
  ]
};

const subMenu = {
  desktop: {
    type: SubMenuType.TABS,
    options: [
      {
        id: 'interiors-suggestions-tab',
        title: 'storageone.combinationsTabTitle',
        sorting: [
          defaultSort('storageone.sortByRecommended'),
          sortByPriceAscending,
          sortByPriceDescending
        ],
        productThumbToolTip: 'name',
        widgets: [
          {
            id: 'interiors-suggestions-layout-message',
            component: InteriorSuggestionsLayoutMessage,
            hidden: noFrameSelected
          },
          {
            id: 'interiors-suggestions-sort-filter-widget',
            component: ProductSortFilterWidget,
            hidden: noFrameSelected
          },
          {
            id: 'interiors-suggestions',
            component: InteriorSuggestions
          }
        ]
      },
      {
        id: 'interior-list-tab',
        title: 'storageone.interiorSuggestionsInteriorsTabTitle',
        sorting: [
          defaultSort('storageone.sortByType'),
          sortByPriceAscending,
          sortByPriceDescending
        ].filter(Boolean) as SortingConfig[],
        widgets: [
          // We add padding widgets to the top and bottom of the filter button because the product list items needs to be
          // misaligned with the screen. The misaligned products makes it clearer that the product list is scrollable.
          {
            id: 'InteriorSuggestionsMenuPadding_top',
            component: () => InteriorSuggestionsMenuPadding()
          } as Widget,
          {
            id: 'interiors-sort-filter-widget',
            component: ProductSortFilterWidget
          },
          {
            id: 'InteriorSuggestionsMenuPadding_bottom',
            component: () => InteriorSuggestionsMenuPadding()
          } as Widget,
          {
            id: 'interior-list',
            component: withProducts(ProductList, interiorsProductListConfig)
          }
        ]
      }
    ]
  },
  mobile: undefined
};

const filters = {
  desktop: [interiorsTypeFilter],
  mobile: []
};

const mainMenu = (_options?: ConfigOptions): MainMenu => {
  return {
    menuTitle: 'storageone.productListInteriorsTitle',
    behaviors: {
      productGroupEntered: [hideDoors, disableDistanceMeasurements],
      productGroupExited: [showDoors, showClothHangersSheet, enableDistanceMeasurements]
    },
    filters: filters[platform],
    widgets: widgets[platform],
    subMenu: subMenu[platform]
  };
};

export default mainMenu;
